module.exports = __webpack_public_path__ + "img/loading_illustration.0d48a61f.svg";